<script>
  import { onMount } from "svelte";

  import { user } from "../stores.js";

  let isSuperUser = false;

  user.subscribe((u) => {
    if (u) {
      u.getIdTokenResult(true).then((res) => {
        isSuperUser = res.claims.superUser;
      });
    }
  });
</script>

<h1>Pickapp Dashboard</h1>

{#if isSuperUser}
  <h2>Hey Admin</h2>
{:else}
  <h2>Not Allowed</h2>
{/if}

<style>
  /* your styles go here */
</style>
